<template>
  <div class="live-form" action="/api/hotel_placement/update_hotel">
    <div v-if="is_legacy">
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <v-layout-select
              label="Select A Hotel"
              :options="hotels"
              :model.sync="id"
              classes="live-skip hotel-placement-hotel"
              :disabled="false"
            ></v-layout-select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text
              label='Name <span style="color: #ff1d25;">*</span>'
              name="name"
              :model.sync="hotel_placement.hotel.name"
              :disabled="new_hotel"
            ></v-layout-text>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text label="Email" name="email" :model.sync="hotel_placement.hotel.email" :disabled="new_hotel"></v-layout-text>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <div>
              <label class="form-control-wrap">Phone <span style="color: #ff1d25;">*</span></label>
              <div class="form-control-wrap">
                <v-phone v-model="hotel_placement.hotel.phone" type="text" class="form-control" name="phone" :disabled="new_hotel"></v-phone>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text label="Fax" name="fax" :model.sync="hotel_placement.hotel.fax" :disabled="new_hotel"> </v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text
              label='Address <span style="color: #ff1d25;">*</span>'
              name="address[address]"
              :model.sync="hotel_placement.hotel.address.address"
              :disabled="new_hotel"
            ></v-layout-text>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text
              label='City <span style="color: #ff1d25;">*</span>'
              name="address[city]"
              :model.sync="hotel_placement.hotel.address.city"
              :disabled="new_hotel"
            ></v-layout-text>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-select
              label='State <span style="color: #ff1d25;">*</span>'
              name="address[state_id]"
              :model.sync="hotel_placement.hotel.address.state_id"
              :disabled="new_hotel"
              :options="states"
            >
            </v-layout-select>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-text
              label='Zip <span style="color: #ff1d25;">*</span>'
              name="address[zip]"
              :model.sync="hotel_placement.hotel.address.zip"
              :disabled="new_hotel"
            ></v-layout-text>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-timepicker
              label='Check In Time <span style="color: #ff1d25;">*</span>'
              name="check_in_time"
              :model.sync="hotel_placement.hotel.check_in_time"
              :disabled="new_hotel"
            ></v-layout-timepicker>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-timepicker
              label='Check Out Time <span style="color: #ff1d25;">*</span>'
              name="check_out_time"
              :model.sync="hotel_placement.hotel.check_out_time"
              :disabled="new_hotel"
            ></v-layout-timepicker>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <v-layout-select
              label="Kitchen"
              name="kitchen"
              :model.sync="hotel_placement.hotel.kitchen"
              :disabled="new_hotel"
              :options="hotel_kitchen"
            ></v-layout-select>
          </div>
        </div>
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <v-layout-select
              label="Breakfast Included?"
              name="breakfast"
              :model.sync="hotel_placement.hotel.breakfast"
              :disabled="new_hotel"
              :options="confirm"
            ></v-layout-select>
          </div>
        </div>
        <div class="col col-sm-4 col-md-6">
          <div class="form-group">
            <v-layout-select
              label="Certifi Form Required"
              name="certifi_required"
              :model.sync="hotel_placement.hotel.certifi_required"
              :disabled="new_hotel"
              :options="confirm"
            ></v-layout-select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <v-layout-select
              label="Pet Friendly"
              name="pets"
              :model.sync="hotel_placement.hotel.pets"
              :disabled="new_hotel"
              :options="confirm"
            ></v-layout-select>
          </div>
        </div>
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <label class="form-control-wrap">Pet Fee</label>
            <div class="form-control-wrap form-control-currency">
              <i class="fas fa-dollar-sign"></i>

              <v-currency
                :is-blank="false"
                v-model="hotel_placement.hotel.pet_fee"
                v-tooltip="hotel_placement.hotel.pet_fee"
                type="text"
                class="form-control"
                name="pet_fee"
                :disabled="new_hotel"
              >
              </v-currency>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <label class="form-control-wrap">Pet: Nightly Rate</label>
            <div class="form-control-wrap form-control-currency">
              <i class="fas fa-dollar-sign"></i>

              <v-currency
                :is-blank="false"
                v-model="hotel_placement.hotel.pet_fee_nightly"
                v-tooltip="hotel_placement.hotel.pet_fee_nightly"
                type="text"
                class="form-control"
                name="pet_fee_nightly"
                :disabled="new_hotel"
              >
              </v-currency>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <label class="form-control-wrap">Valet Parking Rate</label>
            <div class="form-control-wrap form-control-currency">
              <i class="fas fa-dollar-sign"></i>

              <v-currency
                :is-blank="false"
                v-model="hotel_placement.hotel.parking_fee_valet"
                v-tooltip="hotel_placement.hotel.parking_fee_valet"
                type="text"
                class="form-control"
                name="parking_fee_valet"
                :disabled="new_hotel"
              >
              </v-currency>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
        <div class="col col-sm-4 col-md-3">
          <div class="form-group">
            <label class="form-control-wrap">Self Parking Rate</label>
            <div class="form-control-wrap form-control-currency">
              <i class="fas fa-dollar-sign"></i>

              <v-currency
                :is-blank="false"
                v-model="hotel_placement.hotel.parking_fee"
                v-tooltip="hotel_placement.hotel.parking_fee"
                type="text"
                class="form-control"
                name="parking_fee"
                :disabled="new_hotel"
              >
              </v-currency>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-textarea
              label="Kitchen Details"
              name="kitchen_notes"
              :model.sync="hotel_placement.hotel.kitchen_notes"
              :disabled="new_hotel"
            ></v-layout-textarea>
          </div>
        </div>
        <div class="col col-sm-6 col-md-4 col-lg">
          <div class="form-group">
            <v-layout-textarea label="Misc Info" name="info" :model.sync="hotel_placement.hotel.info" :disabled="new_hotel"></v-layout-textarea>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card rounded-0">
      <div class="card-header rounded-0">
        Hotel Details
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="col-12">
            <div class="form-group">
              <v-layout-select
                label="Select A Hotel"
                :options="hotels"
                :model.sync="id"
                classes="live-skip hotel-placement-hotel"
                :disabled="false"
              ></v-layout-select>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text
                label='Name <span style="color: #ff1d25;">*</span>'
                name="name"
                :model.sync="hotel_placement.hotel.name"
                :disabled="new_hotel"
              ></v-layout-text>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text label="Email" name="email" :model.sync="hotel_placement.hotel.email" :disabled="new_hotel"></v-layout-text>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <div>
                <label class="form-control-wrap">Phone <span style="color: #ff1d25;">*</span></label>
                <div class="form-control-wrap">
                  <v-phone v-model="hotel_placement.hotel.phone" type="text" class="form-control" name="phone" :disabled="new_hotel"></v-phone>
                </div>
                <small class="form-text text-danger">Value is invalid.</small>
              </div>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text label="Fax" name="fax" :model.sync="hotel_placement.hotel.fax" :disabled="new_hotel"> </v-layout-text>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text
                label='Address <span style="color: #ff1d25;">*</span>'
                name="address[address]"
                :model.sync="hotel_placement.hotel.address.address"
                :disabled="new_hotel"
              ></v-layout-text>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text
                label='City <span style="color: #ff1d25;">*</span>'
                name="address[city]"
                :model.sync="hotel_placement.hotel.address.city"
                :disabled="new_hotel"
              ></v-layout-text>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-select
                label='State <span style="color: #ff1d25;">*</span>'
                name="address[state_id]"
                :model.sync="hotel_placement.hotel.address.state_id"
                :disabled="new_hotel"
                :options="states"
              >
              </v-layout-select>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-text
                label='Zip <span style="color: #ff1d25;">*</span>'
                name="address[zip]"
                :model.sync="hotel_placement.hotel.address.zip"
                :disabled="new_hotel"
              ></v-layout-text>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-timepicker
                label='Check In Time <span style="color: #ff1d25;">*</span>'
                name="check_in_time"
                :model.sync="hotel_placement.hotel.check_in_time"
                :disabled="new_hotel"
              ></v-layout-timepicker>
            </div>
          </div>
          <div class="col col-sm-6 col-md-4 col-lg">
            <div class="form-group">
              <v-layout-timepicker
                label='Check Out Time <span style="color: #ff1d25;">*</span>'
                name="check_out_time"
                :model.sync="hotel_placement.hotel.check_out_time"
                :disabled="new_hotel"
              ></v-layout-timepicker>
            </div>
          </div>
        </div>
        <div class="form-row align-items-start">
          <div class="col col-sm-4 col-md-3">
            <div class="form-group">
              <v-layout-select
                label="Kitchen"
                name="kitchen"
                :model.sync="hotel_placement.hotel.kitchen"
                :disabled="new_hotel"
                :options="hotel_kitchen"
              ></v-layout-select>
            </div>
          </div>
          <div class="col col-sm-4 col-md-3">
            <div class="form-group">
              <v-layout-select
                label="Breakfast Included?"
                name="breakfast"
                :model.sync="hotel_placement.hotel.breakfast"
                :disabled="new_hotel"
                :options="confirm"
              ></v-layout-select>
            </div>
          </div>
          <div class="col col-sm-4 col-md-6" v-if="hotel_placement.hotel.kitchen != '0'">
            <div class="form-group">
              <v-layout-textarea
                label="Kitchen Details"
                name="kitchen_notes"
                rows="1"
                :model.sync="hotel_placement.hotel.kitchen_notes"
                :disabled="new_hotel"
              ></v-layout-textarea>
            </div>
          </div>
        </div>
        <div class="form-row align-items-start">
          <div class="col col-sm-4 col-md-3">
            <div class="form-group">
              <v-layout-select
                label="Pet Friendly"
                name="pets"
                :model.sync="hotel_placement.hotel.pets"
                :disabled="new_hotel"
                :options="confirm"
              ></v-layout-select>
            </div>
          </div>
          <div class="col col-sm-4 col-md-3">
            <div class="form-group">
              <label class="form-control-wrap">Pet Fee</label>
              <div class="form-control-wrap form-control-currency">
                <i class="fas fa-dollar-sign"></i>

                <v-currency
                  :is-blank="false"
                  v-model="hotel_placement.hotel.pet_fee"
                  v-tooltip="hotel_placement.hotel.pet_fee"
                  type="text"
                  class="form-control"
                  name="pet_fee"
                  :disabled="new_hotel"
                >
                </v-currency>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col col-sm-4 col-md-3 form-check-text">
            <div class="form-group">
              <div class="form-check" tabindex="0">
                <v-checkbox v-model="hotel_placement.hotel.pet_fee_nightly_enabled" class="form-check-input" name="pet_fee_nightly_enabled">
                </v-checkbox>
                <label class="form-check-label">
                  <div class="form-check-label-inner">Pet: Nightly Rate</div>
                  <span class="form-check-custom flex-row-reverse">
                    <small v-if="!hotel_placement.hotel.pet_fee_nightly_enabled" class="ml-2">N/A</small>
                  </span>
                </label>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
            <div class="form-group" v-if="hotel_placement.hotel.pet_fee_nightly_enabled">
              <label class="form-control-wrap">Pet: Nightly Rate</label>
              <div class="form-control-wrap form-control-currency">
                <i class="fas fa-dollar-sign"></i>

                <v-currency
                  :is-blank="false"
                  v-model="hotel_placement.hotel.pet_fee_nightly"
                  v-tooltip="hotel_placement.hotel.pet_fee_nightly"
                  type="text"
                  class="form-control"
                  name="pet_fee_nightly"
                  :disabled="new_hotel"
                >
                </v-currency>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col col-sm-4 col-md-3">
            <div class="form-group">
              <v-layout-textarea
                label="Pet Details"
                name="pet_details"
                rows="1"
                :model.sync="hotel_placement.hotel.pet_details"
                :disabled="new_hotel"
              ></v-layout-textarea>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col col-sm-4 col-md-3 form-check-text">
            <div class="form-group">
              <div class="form-check" tabindex="0">
                <v-checkbox v-model="hotel_placement.hotel.parking_fee_valet_enabled" class="form-check-input" name="parking_fee_valet_enabled">
                </v-checkbox>
                <label class="form-check-label">
                  <div class="form-check-label-inner">Valet Parking Rate</div>
                  <span class="form-check-custom flex-row-reverse">
                    <small v-if="!hotel_placement.hotel.parking_fee_valet_enabled" class="ml-2">N/A</small>
                  </span>
                </label>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
            <div class="form-group" v-if="hotel_placement.hotel.parking_fee_valet_enabled">
              <label class="form-control-wrap">Valet Parking Rate</label>
              <div class="form-control-wrap form-control-currency">
                <i class="fas fa-dollar-sign"></i>

                <v-currency
                  :is-blank="false"
                  v-model="hotel_placement.hotel.parking_fee_valet"
                  v-tooltip="hotel_placement.hotel.parking_fee_valet"
                  type="text"
                  class="form-control"
                  name="parking_fee_valet"
                  :disabled="new_hotel"
                >
                </v-currency>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col col-sm-4 col-md-3 form-check-text">
            <div class="form-group">
              <div class="form-check" tabindex="0">
                <v-checkbox v-model="hotel_placement.hotel.parking_fee_enabled" class="form-check-input" name="parking_fee_enabled"> </v-checkbox>
                <label class="form-check-label">
                  <div class="form-check-label-inner">Self Parking Rate</div>
                  <span class="form-check-custom flex-row-reverse">
                    <small v-if="!hotel_placement.hotel.parking_fee_enabled" class="ml-2">N/A</small>
                  </span>
                </label>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
            <div class="form-group" v-if="hotel_placement.hotel.parking_fee_enabled">
              <label class="form-control-wrap">Self Parking Rate</label>
              <div class="form-control-wrap form-control-currency">
                <i class="fas fa-dollar-sign"></i>

                <v-currency
                  :is-blank="false"
                  v-model="hotel_placement.hotel.parking_fee"
                  v-tooltip="hotel_placement.hotel.parking_fee"
                  type="text"
                  class="form-control"
                  name="parking_fee"
                  :disabled="new_hotel"
                >
                </v-currency>
              </div>
              <small class="form-text text-danger">Value is invalid.</small>
            </div>
          </div>
          <div class="col col-sm-4 col-md-6">
            <div class="form-group">
              <v-layout-select
                label="Certifi Form Required"
                name="certifi_required"
                :model.sync="hotel_placement.hotel.certifi_required"
                :disabled="new_hotel"
                :options="confirm"
              ></v-layout-select>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col col-sm-6">
            <div class="form-group">
              <v-layout-textarea label="Misc Info" name="info" :model.sync="hotel_placement.hotel.info" :disabled="new_hotel"></v-layout-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-hidden v-model="hotel_placement.hotel.full_address" name="full_address"></v-hidden>
    <v-hidden v-model="hotel_placement.original_hotel.id" name="id"></v-hidden>
    <v-hidden v-model="hotel_placement.original_hotel.hotel_id" name="hotel_id"></v-hidden>
    <v-hidden v-model="hotel_placement.id" name="hotel_placement_id"></v-hidden>
  </div>
</template>
<script>
export default {
  props: ["hotel_placement", "is_legacy"],
  data() {
    return {
      newHotelLoaded: false,
      id: this.hotel_placement.original_hotel.id
    };
  },
  watch: {
    id(newID, oldID) {
      if (newID == oldID || newID == null || newID == "") return;

      if (this.newHotelLoaded && oldID != "") {
        this.newHotelLoaded = false;
        return;
      }

      let $this = this;
      let el = $(this.$el).find(".hotel-placement-hotel");
      if (el.attr("disabled")) return;
      el.attr("disabled", true);

      let index = $(".hotel-placement-hotel").index(el[0]);
      if (newID == 0) {
        $.ajax({
          url: "/api/hotel/create",
          method: "POST",
          dataType: "json",
          success: response => {
            const hotel_placement = !app.placement ? this.hotel_placement : app.placement.hotel_placements[index];
            hotel_placement.hotel = response["updated"];
            hotel_placement.hotel_id = response["updated"].id;
            hotel_placement.card_id = response["updated"].card_id;
            hotel_placement.virtual_card_id = response["updated"].virtual_card_id;
            //   hotel_placement.is_virtual_card = response['updated'].is_virtual_card;
            hotel_placement.original_hotel = response["updated"];
            merge_model(hotel_placement.hotel, app.models.hotel);
            merge_model(hotel_placement.original_hotel, { ...app.models.hotel, hotel_id: null });
            $this.$emit("hotel_change");
            setTimeout(function() {
              el.attr("disabled", false);
            }, 250);
          },
          error: function(response) {
            setTimeout(function() {
              el.attr("disabled", false);
            }, 250);
          }
        });
      } else {
        $.ajax({
          url: "/api/hotel/get",
          method: "POST",
          data: {
            id: newID
          },
          dataType: "json",
          success: response => {
            const hotel_placement = !app.placement ? this.hotel_placement : app.placement.hotel_placements[index];

            hotel_placement.hotel = response;
            hotel_placement.hotel_id = response.id;
            hotel_placement.card_id = response.card_id;
            hotel_placement.virtual_card_id = response.virtual_card_id;
            hotel_placement.certifi_required = response.certifi_required;
            //   hotel_placement.is_virtual_card = response.is_virtual_card;
            hotel_placement.original_hotel = {
              ...response,
              hotel_id: null
            };
            merge_model(hotel_placement.hotel, app.models.hotel);
            merge_model(hotel_placement.original_hotel, { ...app.models.hotel, hotel_id: null });
            setTimeout(function() {
              el.closest("form").submit();
              el.attr("disabled", false);
            }, 250);
            $this.$emit("hotel_change");
          },
          error: function(response) {
            setTimeout(function() {
              el.attr("disabled", false);
            }, 250);
          }
        });
      }
    }
  },
  computed: {
    is_in_hotels() {
      return this.$root.placement_hotels.find(hotel => hotel.id == this.id);
    },
    new_hotel() {
      return !this.id && !this.hotel_placement.hotel.id;
    },
    hotels() {
      return this.$root.placement_hotels;
    },
    states() {
      return this.$root.options.states;
    },
    confirm() {
      return this.$root.options.confirm;
    },
    hotel_kitchen() {
      return this.$root.options.hotel_kitchen;
    }
  },
  mounted() {
    if (!this.is_in_hotels && !this.newHotelLoaded) {
      this.newHotelLoaded = true;
      this.id = this.hotel_placement.hotel.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/hotel-manager.vue